import { useEffect, useRef, useState } from 'react'

import {
  useStore, gumballStore, premioGumballStore,
} from '../../store/uiStore'
import { IS_TOUCH } from '../../config/touch'
import { caricaStatoGumball, CHIAVE_PREMI } from '../../config/gumball'
import useCart from '../../hooks/useCart'

// ============================================================
// LA PARTE DOM DELLA MACCHINETTA. Tre compiti:
//  1. chiede al server, una volta all'avvio, se la macchinetta e' accesa
//     e se da qui si puo' giocare (caricaStatoGumball);
//  2. appena arriva un premio con un codice, lo ATTACCA AL CARRELLO
//     Shopify: chi vince non deve copiare niente, lo sconto scatta al
//     pagamento;
//  3. sotto la pallina aperta dice come chiuderla (e dove e' finito il
//     codice), e fuori dalla giocata mostra gli avvisi ("hai gia' giocato").
//
// Il premio NON sta qui: e' scritto sul biglietto dentro la pallina, fra
// le due meta' (Gumball.jsx). Il mouse resta agganciato: basta E, un click
// o un tocco.
// ============================================================
const dataBreve = (ms) =>
  new Date(ms).toLocaleDateString('it-IT', { day: 'numeric', month: 'long' })

export default function GumballPremio() {
  const fase = useStore(gumballStore)
  const premio = useStore(premioGumballStore)
  const { applyDiscountCode } = useCart()
  const [nelCarrello, setNelCarrello] = useState(null) // codice applicato

  useEffect(() => { caricaStatoGumball() }, [])

  // Un codice si applica una volta sola, anche se lo store avvisa di nuovo
  const applicati = useRef(new Set())
  useEffect(() => {
    const codice = premio?.codice
    if (!codice || premio.prova || applicati.current.has(codice)) return
    applicati.current.add(codice)
    // il carrello Shopify sa solo il codice: il nome del premio lo ricorda
    // il browser, per lo scontrino ("Spedizione gratis", non "Codice sconto")
    try {
      const premi = JSON.parse(localStorage.getItem(CHIAVE_PREMI)) || {}
      premi[codice] = { titolo: premio.titolo, id: premio.id }
      localStorage.setItem(CHIAVE_PREMI, JSON.stringify(premi))
    } catch {
      // niente: lo scontrino dira' "Codice sconto"
    }
    applyDiscountCode(codice)
      .then(() => setNelCarrello(codice))
      .catch(() => {}) // resta scritto sul biglietto: si puo' inserire al checkout
  }, [premio, applyDiscountCode])

  // Gli avvisi della macchinetta («si e' inceppata», «hai gia' giocato», «non
  // e' ancora in funzione») li dice la MASCOTTE: Guida.jsx legge
  // `avvisoGumballStore` da se'. Qui resta solo il premio aperto.
  if (fase !== 'apre' || !premio) return null

  let nota = null
  if (premio.prova) {
    nota = <span className="gumball-prova">prova — premio non reale</span>
  } else if (premio.codice) {
    nota = (
      <span className="gumball-nota">
        {nelCarrello === premio.codice ? 'Già nel carrello' : 'Codice valido'}
        {premio.scade ? `, fino al ${dataBreve(premio.scade)}` : ''}
      </span>
    )
  }

  return (
    <div className="gumball-chiudi" aria-live="polite">
      {/* per chi non vede la scena, il premio va detto a parole */}
      <span className="sola-lettura">{premio.titolo}. {premio.testo}</span>
      {nota}
      {IS_TOUCH ? 'Tocca per chiudere' : <>Premi <kbd>E</kbd> per chiudere</>}
    </div>
  )
}
